module.exports = __webpack_public_path__ + "img/box2_icon1.71f9571f.png";